<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <el-autocomplete
        :disabled="!isedite"
        :style="inputStyle"
        :placeholder="placeholder"
        :clearable="true"
        v-model="val"
        :fetch-suggestions="handleFetchSuggestions"
        ref="component"
        @keyup.enter.native="handleEnter"
        @select="handleEnter"
        @blur="handleBlur"
      />
      <!-- :trigger-on-focus="false"  -->
    </el-tooltip>
  </div>
</template>

<script>
import Validator from '../../utils/validator.js'
import _ from 'lodash'

export default {
  name: 'jtGroupProject',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    minLength: {
      type: Number,
      default: 0,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
      lableStyle: {
        width: this.labelWidth,
      },
      inputStyle: {
        width: this.compWidth,
      },
      hasFiredEnterEventHandler: false,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      try {
        this.hasFiredEnterEventHandler = true
        this.$emit('enter')
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    handleBlur() {
      let time = 0
      if (this.val === '') {
        time = 300
      }
      _.delay(() => {
        try {
          if (this.hasFiredEnterEventHandler) {
            this.hasFiredEnterEventHandler = false
            return
          }
          this._save()
        } catch (err) {
          this.$emit('datas', err, null)
        }
      }, time)
    },
    handleFetchSuggestions(queryString, cb) {
      let suggestions = this.suggestions
      if (queryString) {
        suggestions = _.filter(this.suggestions, (item) => {
          return (
            item.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
          )
        })
      }

      cb(suggestions)
    },
    _validate(value) {
      const min = this.minLength
      const max = this.maxLength
      const minErrMsg = this.$t('groupProject.MIN_LENGTH', { min })
      const maxErrMsg = this.$t('groupProject.MAX_LENGTH', { max })

      Validator.isLength(value, { min }, minErrMsg)
      Validator.isLength(value, { max }, maxErrMsg)
    },
    _save() {
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        this._validate(value)
        this.val = value
      }

      this.$emit('datas', null, value)
    },
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
</style>
